import { render, staticRenderFns } from "./SampleCard.vue?vue&type=template&id=1006ebf8"
import script from "./SampleCard.vue?vue&type=script&lang=js"
export * from "./SampleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports